<template>
    <div
        v-if="isGuideChat"
        id="wave">
        <span class="dot" />
        <span class="dot" />
        <span class="dot" />
    </div>
    <div v-else>
        <svg
            style="visibility: hidden; position: absolute; top: 0; left: 0; overflow: hidden; width: 0; height: 0;"
            xmlns="http://www.w3.org/2000/svg">
            <defs>
                <linearGradient
                    id="ai-gradient"
                    gradientTransform="rotate(1)">
                    <stop
                        class="ai-gradient-stop-0"
                        offset="8.05%" />
                    <stop
                        class="ai-gradient-stop-1"
                        offset="31.31%" />
                    <stop
                        class="ai-gradient-stop-2"
                        offset="66.93%" />
                </linearGradient>
            </defs>
        </svg>
        <pendo-progress-bar
            v-bind="$attrs"
            ref="progressBar"
            :colors="progressColors" />
    </div>
</template>

<script>
import { PendoProgressBar } from '@pendo/components';

export default {
    name: 'AiChatLoading',
    components: {
        PendoProgressBar,
    },
    props: {
        isGuideChat: {
            type: Boolean,
            default: true,
        },
    },
    data () {
        return {
            progressColors: {
                default: {
                    fill: 'var(--palette-gray-40)',
                    stroke: 'var(--palette-gray-40)',
                },
                progress: {
                    fill: 'url(#ai-gradient)',
                    stroke: 'url(#ai-gradient)',
                },
                complete: {
                    fill: 'url(#ai-gradient)',
                    stroke: 'url(#ai-gradient)',
                },
            },
        };
    },
    mounted () {
        if (!this.isGuideChat) {
            this.$nextTick(() => {
                this.$refs.progressBar.start();
            });
        }
    },
};
</script>

<style scoped lang="less">
@import '@/voc/styles/voc.style.less';

div#wave {
    background-color: var(--palette-gray-20);
    border-radius: 45% 45% 45% 15%;
    text-align: center;
    width: 50px;
    height: 30px;

    .dot {
        display: inline-block;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        margin-right: 3px;
        background: var(--palette-gray-60);
        animation: wave 1.3s linear infinite;

        &:nth-child(2) {
            animation-delay: -1.1s;
        }

        &:nth-child(3) {
            animation-delay: -0.9s;
        }
    }
}

@keyframes wave {
    0%,
    60%,
    100% {
        transform: translateY(5px);
    }

    30% {
        transform: translateY(-2px);
    }
}

.ai-gradient-stop-0 {
    stop-color: @ai-gradient-0;
}

.ai-gradient-stop-1 {
    stop-color: @ai-gradient-1;
}

.ai-gradient-stop-2 {
    stop-color: @ai-gradient-2;
}
</style>
